export default {
  defaultTitle: "HR System",
  param_btn_search: "查询",
  param_btn_search_more: "更多查询",
  param_btn_search_more_hide: "隐藏更多查询",
  btn_save: "保存",
  btn_back: "返回",
  btn_close: "关闭",
  btn_enter:"确定",
  existed:"记录已经存在，请检查!",

  Add:"新增",
  Edit:"编辑",
  Copy:"复制",
  Delete:"删除",
  View:"查看",
  copyClumn: "复制",
  viewClumn: "查看",
  editClumn:"编辑",
  deleteClumn:"删除",
  selectClumn:"选择",
  mcard:"打印厂牌",
  selAll:"选择所有行",

  dateSel:"选择日期",

  pager_btn_first: "第一页",
  pager_btn_pre: "上一页",
  pager_btn_next: "下一页",
  pager_btn_last: "最后一页",
  pager_pageNo: "当前页",
  pager_pageCount: "总页数",
  pager_pageSize: "每页行数",
  pager_rowCount: "总行数",
  pager_export_excel: "导出Excel",

  loginNameTitle:"用户名",
  loginNameMsg:"请先输入用户名！",
  passwordTitle:"密码",
  passwordMsg:"请先输入密码！",
  loginBtnTitle:"登陆",
  uopMsg:"用户名或密码错误，请重新输入！",

  msgSysError: "操作失败，请稍后再试！",
  msg_system_error: "操作失败，请联系管理员!",
  msg_save_success: "保存成功!",
  msg_action_success: "操作成功!",
  msg_save_success_back: "保存成功!\r\n是否返回列表页面？",
  msg_del_success: "删除成功",
  msg_record_exists:"记录已经存在，请检查！",
  msg_delConf: "你是否确认删除 {0}？",
  msg_no_rights:"无权限执行此操作，请联系管理员！",



  /// icon class
  icon_add:"iconfont icon-add",
  icon_copy:"iconfont icon-copy",
  icon_edit:"iconfont icon-edit",
  icon_view:"iconfont icon-chakan",
  icon_delete:"iconfont icon-custom-delete",
  icon_print:"iconfont icon-print",
  icon_import:"iconfont icon-icimport",
  icon_export:"iconfont icon-save",
  icon_excel:"iconfont icon-microsoftexcel",
  icon_word:"iconfont icon-word",
  icon_pdf:"iconfont icon-pdf",

  export_excel:"Excel",
  export_word:"Word",
  export_pdf:"PDF"
}
